export const KEY = 'network';

export const NETWORK_ERROR = 'networkError';
